/* AMBYRTEK — LAUNCH EDITION JS */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Prioritise the first visible product/hero image without changing Shopify's lazy-loading strategy below the fold.
  const prioritizeFirstImage = () => {
    const candidates = document.querySelectorAll('main img');
    for (const img of candidates) {
      const rect = img.getBoundingClientRect();
      if (rect.width > 80 && rect.height > 80 && rect.top < window.innerHeight * 1.15) {
        img.setAttribute('fetchpriority', 'high');
        if (img.loading === 'lazy') img.loading = 'eager';
        break;
      }
    }
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(prioritizeFirstImage, { timeout: 800 });
  } else {
    window.setTimeout(prioritizeFirstImage, 250);
  }

  // Make the pointer atmosphere sleep when the tab is hidden, reducing background work.
  if (!reduce && document.visibilityState !== undefined) {
    const root = document.documentElement;
    document.addEventListener('visibilitychange', () => {
      root.classList.toggle('ambyrtek-tab-hidden', document.hidden);
    });
  }

  // Don't run custom reveal observers in the Shopify theme editor.
  if (window.Shopify && Shopify.designMode) return;

  // Mark the page ready after the first paint so CSS can avoid any first-render flash.
  const ready = () => document.documentElement.classList.add('ambyrtek-launch-ready');
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }
})();
